// Shared inline tweet embedding policy. Update the depth cap here and every consumer stays in sync.
export const INLINE_TWEET_MAX_DEPTH = 3;

export function canRenderAnotherInlineTweet(visitedIds: ReadonlySet<string> | undefined) {
  const depth = visitedIds?.size ?? 0;
  return depth + 1 <= INLINE_TWEET_MAX_DEPTH;
}
